import {
	FETCH_ERROR_REPORTS_BEGIN,
	FETCH_ERROR_REPORTS_SUCCESS,
	FETCH_ERROR_REPORTS_ERROR,
} from "../actions/errorReportActions"

const initialState = {
	reports: [],
	fetchReports: {
		loading: false,
		error: false,
	},
}

export default function errorReportReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_ERROR_REPORTS_BEGIN:
			return {
				...state,
				fetchReports: { loading: true, error: false },
			}
		case FETCH_ERROR_REPORTS_SUCCESS:
			return {
				...state,
				// append : page suivante (« Charger plus ») — concatène en
				// dédupliquant par id.
				reports: action.payload.append
					? [
							...state.reports,
							...action.payload.reports.filter(
								(r) =>
									!state.reports.some((s) => s.id === r.id),
							),
						]
					: action.payload.reports,
				fetchReports: { loading: false, error: false },
			}
		case FETCH_ERROR_REPORTS_ERROR:
			return {
				...state,
				fetchReports: { loading: false, error: action.payload },
			}
		default:
			return state
	}
}
